/** @jsx jsx */
import { jsx } from '@emotion/react';

type Props = {
  className?: string;
};

const ConduitSvg = ({ className }: Props) => (
  <svg className={className} viewBox="0 0 720 500" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g clipPath="url(#clip0_conduit)">
      {/* Darkest arc (back) */}
      <path
        d="M566.885 190.881L504.314 -19.6929C353.37 23.7477 237.446 143.523 199.891 294.844C162.335 446.166 208.803 606.244 321.92 715.22L475.688 558.338C419.13 503.85 395.895 423.811 414.673 348.15C433.451 272.489 491.413 212.602 566.885 190.881Z"
        fill="var(--cds-color-emphasis-primary-background-xstrong)"
      />
      {/* Front arc (middle) */}
      <path
        d="M691.74 159.637L619.692 -82.8326C445.885 -32.8121 312.402 105.105 269.158 279.347C225.914 453.589 279.42 637.914 409.671 763.397L586.729 582.752C521.605 520.01 494.851 427.848 516.473 340.727C538.095 253.606 604.837 184.647 691.74 159.637Z"
        fill="var(--cds-color-emphasis-primary-background-default)"
      />
      {/* Stroke arc (outline) */}
      <path
        d="M690.911 57.1366C571.914 60.41 469.636 142.639 440.942 258.256C412.247 373.872 464.209 494.381 567.867 552.914L439.857 781.6C233.14 665.378 129.442 425.373 186.585 195.128C243.729 -35.117 447.613 -198.785 684.684 -204.865L690.911 57.1366Z"
        stroke="var(--cds-color-emphasis-primary-stroke-default)"
        strokeWidth="2"
        fill="none"
      />
    </g>
    <defs>
      <clipPath id="clip0_conduit">
        <rect width="720" height="500" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ConduitSvg;
